import React, { useRef, useEffect } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { Box } from '@mui/material'
import AdminNavbar from '../components/Navbars/AdminNavbar'
import AdminFooter from '../components/Footers/AdminFooter'
import InfluencerSidebar from '../components/Sidebar/InfluencerSidebar'
import influencerRoutes from '../influencerRoutes'

function Influencer(props) {
  const divRef = useRef(null)

  useEffect(() => {
    document.documentElement.scrollTop = 0
    document.scrollingElement.scrollTop = 0
    if (divRef.current) divRef.current.scrollTop = 0
  }, [])

  const getRoutes = () =>
    influencerRoutes.map((prop, key) => (
      <Route
        path={prop.layout + prop.path}
        component={prop.component}
        key={key}
      />
    ))

  const getBrandText = () => {
    const match = influencerRoutes.find(
      route => props.location.pathname.indexOf(route.layout + route.path) !== -1
    )
    return match ? match.name : 'Influencer'
  }

  return (
    <Box sx={{ backgroundColor: 'background.default', minHeight: '100vh' }}>
      <InfluencerSidebar />
      <Box
        sx={{
          marginLeft: { xs: 0, sm: '260px' },
          paddingTop: { xs: 8, sm: 0 },
          minHeight: '100vh',
          minWidth: 0,
          maxWidth: '100%',
          overflowX: 'hidden'
        }}
        ref={divRef}>
        <AdminNavbar {...props} brandText={getBrandText()} />
        <Box sx={{ px: { xs: 2, sm: 3, md: 4 }, pb: 4 }}>
          <Switch>
            {getRoutes()}
            <Redirect from="/influencer" to="/influencer/home" />
          </Switch>
        </Box>
        <AdminFooter />
      </Box>
    </Box>
  )
}

export default Influencer
